// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { externalLinkOpen } from '../../actions/externallink';
import { doAddFavorite, doDelFavorite } from '../../actions/favorites';
import useBindActionsCreator from '../../hooks/useBindActionsCreator';
import useMergeProps from '../../hooks/useMergeProps';
import useRouter from '../../hooks/useRouter';

import RowFactory from './RowFactory';
import makeRowFactorySelector from './RowFactory.selector';

const RowFactoryContainer = (ownProps: unknown) => {
  const {
    location: { pathname },
    params: { categoryId, tournamentId },
  } = useRouter();
  const {
    matchId,
    listBetIds,
    isBetFiltered,
    separatorType,
    promotionImage,
    promotionUrl,
    promotionWamUrl,
    promotionMissionId,
  } = ownProps;

  const selectRowFactory = useMemo(() => makeRowFactorySelector(), []);

  const selectedProps = useSelector((state) =>
    selectRowFactory(state, {
      matchId,
      listBetIds,
      isBetFiltered,
      separatorType,
      promotionImage,
      promotionUrl,
      promotionWamUrl,
      missionId: promotionMissionId,
      categoryId,
      tournamentId,
      pathname,
    }),
  );

  const onFavoriteButtonClicked = useCallback(
    (isFavorite: boolean) => (dispatch) => {
      if (isFavorite) {
        dispatch(doDelFavorite({ matchId }));
      } else {
        dispatch(doAddFavorite({ matchId }));
      }
    },
    [matchId],
  );

  const actions = useMemo(
    () => ({
      onFavoriteButtonClicked,
      openExternalLink: externalLinkOpen,
    }),
    [onFavoriteButtonClicked],
  );

  const actionsProps = useBindActionsCreator(actions);

  const enhancedProps = useMergeProps({ ownProps, selectedProps, actionsProps });

  return <RowFactory {...enhancedProps} />;
};

export default RowFactoryContainer;
